import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicFilterPipe } from 'src/app/Pipes/basic-filter.pipe';
import { ReportsComponent } from '../website/reports/reports.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [BasicFilterPipe, ReportsComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports:[BasicFilterPipe, ReportsComponent]
})
export class SharedModule { }
